/* eslint-disable react/jsx-no-constructed-context-values */
import React, { useContext, createContext, useCallback } from 'react';
import api from '../services/api';
import { IPix } from '../models/IOrder';

interface PixData {
  getPix: (pixId: string) => Promise<IPix>;
  deletePix: (pixId: string) => Promise<void>;
  postPixMenu: (body: PixMenuOrder) => Promise<IPix>;
  postPixTable: (body: PixTableOrder) => Promise<IPix>;
}
export interface PixMenuOrder {
  orderPixTransactionId: string;
  total: number;
  orderType: string;
}
export interface PixTableOrder {
  tableHash: string;
  tableOrderTransactionId: string;
  total: number;
  orderType: string;
}

const Pix = createContext<PixData>({} as PixData);

interface IPixProvider {
  children: React.ReactNode;
}

export const PixProvider: React.FC<IPixProvider> = ({ children }) => {
  const deletePix = useCallback(async (pixId: string) => {
    await api.delete(`/restricted/pix/${pixId}`);
  }, []);
  const getPix = useCallback(async (pixId: string) => {
    const { data } = await api.get(`/restricted/pix/${pixId}`);
    return data;
  }, []);

  const postPixTable = useCallback(async (body: PixTableOrder) => {
    const { data } = await api.post<IPix>('/pix/table-order', body);
    return data;
  }, []);

  const postPixMenu = useCallback(async (body: PixMenuOrder) => {
    const { data } = await api.post<IPix>('/pix/menu-order', body);
    return data;
  }, []);

  return (
    <Pix.Provider value={{ getPix, postPixMenu, deletePix, postPixTable }}>{children}</Pix.Provider>
  );
};

export function usePix(): PixData {
  const context = useContext(Pix);

  if (!context) {
    throw new Error('usePix must be used within PixProvider');
  }

  return context;
}
